import React, { useEffect, useState } from 'react';
import './game-dashboard.styles.scss';
import Chart3 from './chart3.component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare, faBell, faFlask, faUsers } from '@fortawesome/free-solid-svg-icons';
import { Link, useNavigate } from 'react-router-dom';
import ActivityList from './activity-list.component';
import { useSelector } from 'react-redux';
import FeaturedContent from './featured-content.component';
import MessageCreator from './message-creator.component';
import LeadersList from './leaders-list.component';
import DataCard from './data-card.component';
import GameDashboardMobile from './game-dashboard-mobile.component';
import Chart4 from './chart4.component';

const GameDashboard = ({
  gameData,
  defaultActivityRecords,
  gameActivity, // DEPRECATED
  playerList,
  gameElements,
  latestMessage,
  actionItems,
  gameManagers,
  activityCounts,
  role
}) => {

  const screenSize = useSelector(state => state.contentData.screenSize);
  const navigate = useNavigate();

  useEffect(() => {
    if (!gameData) return;
    const pageTitleEl = document.getElementById('page-title');
    if (pageTitleEl) {
      pageTitleEl.innerText = 'Game Management';
    }
  }, [gameData])

  return (
    <div className='game-dashboard'>
      {
        (
          gameData &&
          (
            screenSize === 'desktop' ||
            screenSize === 'largeTablet' ||
            screenSize === 'tablet'
          )
        ) &&
        <div className={`game-dashboard-content ${screenSize}`}>
          <div className='player-count'>
            <DataCard
              icon={faUsers}
              data={gameData.playerCount ?? 0}
              text='Players'
              onclick={() => navigate('players')}
              role={role}
            />
          </div>
          {/* <Link to='players'>
                        <div className='data-box player-count g-card clickable'>
                            <div className='icon-circle'>
                                <FontAwesomeIcon icon={faUsers} size='xl' />
                            </div>
                            <div className='data-div'>
                                <div className='data-number'>
                                    {gameData.playerCount ?? 0}
                                </div>
                                <div className='data-text'>
                                    Players/Teams
                                </div>
                            </div>
                        </div>
                    </Link> */}
          <div className='pending-action-items'>
            <DataCard
              icon={faBell}
              data={
                actionItems ?
                  Object.values(actionItems)
                    .filter(a => a.status === 'pending')
                    .length :
                  0
              }
              text='Pending'
              // onclick={() => navigate('actionitems')} 
              role={role}
            />
          </div>
          {/* <Link to='actionitems'>
                        <div className='data-box box2 g-card clickable'>
                            <div className='icon-circle'>
                                <FontAwesomeIcon icon={faBell} size='xl' />
                            </div>
                            <div className='data-div'>
                                <div className='data-number'>
                                    {gameData.elementCount ?? 0}
                                </div>
                                <div className='data-text'>
                                    Action Items
                                </div>
                            </div>
                        </div>
                    </Link> */}
          <div className='element-count'>
            <DataCard
              icon={faFlask}
              data={gameData.createdElementTotal ?? 0}
              text='Game Elements'
              onclick={() => navigate('elements')}
              role={role}
            />
          </div>
          {/* <Link to='elements'>
                        <div className='data-box box3 g-card clickable'>
                            <div className='icon-circle'>
                                <FontAwesomeIcon icon={faFlask} size='xl' />
                            </div>
                            <div className='data-div'>
                                <div className='data-number'>
                                    {gameData.createdElementTotal ?? 0}
                                </div>
                                <div className='data-text'>
                                    Game Elements
                                </div>
                            </div>
                        </div>
                    </Link>	 */}
          <div className='activity-box'>
            <div className='g-card activity-card' id='activity-card'>
              <div className='activity-card-title'>
                <span>Activity</span>
                <button
                  className='g-button text-only'
                  onClick={() => navigate(`activity`)}
                >
                  <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
                </button>
              </div>
              <hr />
              <ActivityList
                gameActivity={defaultActivityRecords}
                playerList={playerList}
                gameManagers={gameManagers} />
            </div>
          </div>
          <div className='graph-box' id='graph-box'>
            <div className='g-card' >
              <div className='chart-text'>
                Activity Over Last 10 Days
              </div>
              {
                (activityCounts) &&
                <Chart4 activityCounts={activityCounts} />
              }
            </div>
          </div>
          <div className='leaders-box'>
            <div className='g-card' id='leader-card'>
              <span>Leaders</span>
              {
                (
                  gameData.sortLeaders === 'currency' || 
                  gameData.sortLeaders === 'currencyTotal' 
                  ? <span>&nbsp;&#129689;</span> 
                  : <span>&nbsp;💎</span>
                )
              }
              <hr />
              <LeadersList
                gameData={gameData}
                playerList={playerList}
                role={role} />
            </div>
          </div>
          <div className='feature-box'>
            <div className='g-card'>
              <div>Featured Element</div>
              <hr />
              <FeaturedContent
                gameData={gameData}
                gameElements={gameElements}
                role={role} />
            </div>
          </div>
          <div className='message-box'>
            <div className='g-card' id='message-card'>
              <div>Game News</div>
              <hr />
              <MessageCreator
                gameData={gameData}
                latestMessage={latestMessage}
                role={role} />
            </div>
          </div>
          {/* <div className='box6'>
                        <div className='g-card'>
                            
                        </div>
                    </div> */}
          {/* <div className="g-space-1"></div> */}
          {/* <div className="g-space-1"></div> */}
        </div>
      }
      {
        (gameData &&
          (screenSize === 'mobile')
        ) &&
        <GameDashboardMobile
          gameData={gameData}
          gameActivity={gameActivity}
          defaultActivityRecords={defaultActivityRecords}
          playerList={playerList}
          gameElements={gameElements}
          latestMessage={latestMessage}
          actionItems={actionItems}
          activityCounts={activityCounts}
          gameManagers={gameManagers}
          role={role} />
      }

    </div>
  )
}

export default GameDashboard